import {InputField} from 'components'
import {MenuItem} from "@material-ui/core";
const SimpleSelectField = ({
     control,
     segment,
     id,
     name,
     label,
     disabled = false,
     trueLabel = 'Sim',
     falseLabel = 'Não'
    }) => {
    return(
        <>
            <InputField select
                id={`${id}.${segment}.${name}`}
                name={`${id}.${segment}.${name}`}
                label={label}
                disabled={disabled}
                control={control}>
                <MenuItem value={1} >{trueLabel}</MenuItem>
                <MenuItem value={0} >{falseLabel}</MenuItem>
            </InputField>
        </>
    )
}

export default SimpleSelectField
